import { render } from "./Unauthorized.vue?vue&type=template&id=c3eb9816"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Error/Unauthorized.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3eb9816"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3eb9816', __exports__)) {
    api.reload('c3eb9816', __exports__)
  }
  
  module.hot.accept("./Unauthorized.vue?vue&type=template&id=c3eb9816", () => {
    api.rerender('c3eb9816', render)
  })

}


export default __exports__